import "./App.css";
import Login from "./Components/Login/Login";
import ApiDocsLogin from "./Components/Login/ReadmeLogin";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PaymentPage from "./Components/Dashboard/Payments/paymentPage";
import MainPaymentPage from "./Components/Dashboard/Payments/MainPaymentPage";
import Apple from "./Components/Dashboard/Payments/applePaySDK";
import FirebaseTest from "./Components/Dashboard/Payments/firebase";
import PolicyDocs from "./Components/Dashboard/Payments/PolicyDocs";
import ForgotPassword from "./Components/Login/ForgotPassword";
import Invoice from "./Components/Dashboard/Payments/Invoice";
import TheHub from "./Components/Dashboard/TheHub";
import DocumentSearchPage from "./Components/Dashboard/DocumentSearch/DocumentSearchPage";
import OneAppSuccess from "./Components/Dashboard/Payments/OneAppSuccess";
import OneAppError from "./Components/Dashboard/Payments/OneAppError";
import { SignatureProvider } from "./DocuSeal/Components/SignatureContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <Router>
      <SignatureProvider>
        <Routes>
          {/* Route for the login page */}
          <Route path="/" element={<Login />} />
          {/* Route for API documentation login page */}
          <Route path="/api-docs" element={<ApiDocsLogin />} />
          {/* Route for the home page */}
          <Route path="/hub" element={<TheHub />} />
          <Route path="/tap" element={<PaymentPage />} />
          <Route path="/payment" element={<MainPaymentPage />} />
          <Route path="/apple" element={<Apple />} />
          <Route path="/firebase" element={<FirebaseTest />} />
          <Route path="/policy-documents" element={<PolicyDocs />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/invoice" element={<Invoice />} />
          <Route path="/one-success" element={<OneAppSuccess />} />
          <Route path="/one-error" element={<OneAppError />} />
          <Route path="/document-search" element={<DocumentSearchPage />} />
        </Routes>
      </SignatureProvider>
      <ToastContainer />
    </Router>
  );
}

export default App;
